import React, {useRef, useState} from 'react';
import {connect} from "react-redux";
import {FormattedMessage} from "react-intl";

import {getFeatureEditPermission, getFilteredFeatures} from "./featuresFunctions";
import useOutsideClick from "../../utilities/helperHooks";
import FeaturesSetupTopPanelLeftSelectItem from "./FeaturesSetupTopPanelLeftSelectItem";
import {showNewFeatureOverlay} from "../FeatureCreator/NewFeature/NewFeatureActions";


const FeaturesSetupTopPanelLeft = (props) => {

  const {featuresList, featuresListReceived, canAddNewFeatures, showNewFeatureOverlay, groupName} = props;

  const [opened, setOpened] = useState(false);
  const selectElement = useRef(null);

  const addNewWizardItem = () => {
    if (!canAddNewFeatures) {
      return false
    }
    showNewFeatureOverlay(true, groupName)
  }

  useOutsideClick(selectElement, () => {
    setOpened(false);
  }, ["select3-dropdown__list-item", "ui-svg-checkbox__icon", "ui-svg-checkbox__icon-checked-icon"]);

  const selectItems = ["features.setup.selectAll", "features.setup.selectEnabled", "features.setup.selectDisabled"];
  const selectItemHeight = 33;
  const styles = {
    height: opened ? (selectItems.length * selectItemHeight) + 1 + "px" : 0
  }

  return (
    <div className="fs-top__item fs-top__item--left">
      {canAddNewFeatures ? (
        <button className={"ui-button5 ui-button5--green ui-button5--add" + (!canAddNewFeatures ? " ui-button5--disabled" : "")}
                disabled={!canAddNewFeatures}
                onClick={addNewWizardItem}>
          <span className="ui-button-icon ui-button-icon--add"/>
          <FormattedMessage id="features.setup.newFeature"/>
        </button>
      ) : null}
      <div className={"select3 select--gray ui-select--180 margin-l5 " + (opened ? " select3--active" : "")} ref={selectElement}>
        <div className="select-value" onClick={() => setOpened(!opened)}>
          <span className="select-value__text">
            <FormattedMessage id={"features.setup.selectFeatures"}/>
          </span>
          <span className="select-value__button"/>
        </div>
        <div className="select3-dropdown" style={styles}>
          {!featuresListReceived ? <div className={"ui-loader ui-loader--medium"}/> : (
            <ul className={"select3-dropdown__list select3-dropdown__list--flex-column"}>
              {selectItems.map((selectItem) => {
                let itemFeatures = [];
                switch (selectItem) {
                  case "features.setup.selectAll":
                    itemFeatures = featuresList;
                    break;
                  case "features.setup.selectEnabled":
                    itemFeatures = featuresList.filter(feature => feature.isEnabled)
                    break;
                  case "features.setup.selectDisabled":
                    itemFeatures = featuresList.filter(feature => !feature.isEnabled)
                    break;
                  default:
                    break;
                }
                if (!itemFeatures.length) {
                  return null
                }
                return <FeaturesSetupTopPanelLeftSelectItem intlKey={selectItem}
                                                            itemFeatures={itemFeatures}
                                                            key={selectItem}/>
              })}
            </ul>
          )}
        </div>
      </div>
      {/*<button className={"ui-button--add ui-button5 ui-button5--gray ui-button5--select-all"*/}
      {/*  + (allSelected ? " ui-button5--select-all--active" : "")*/}
      {/*  + (!featuresList.length || allSelected ? " ui-button5--disabled" : "")}*/}
      {/*        onClick={() => changeSelectedClick(true)}>*/}
      {/*  <span className="ui-button-icon ui-button-icon--grid"/>*/}
      {/*  <FormattedMessage id="wizard.selectAllButton"/>*/}
      {/*</button>*/}
      {/*<button className={"ui-button--add ui-button5 ui-button5--gray ui-button5--deselect-all"*/}
      {/*  + (allDeselected ? " ui-button5--deselect-all--active" : "")*/}
      {/*  + (!featuresList.length || allDeselected ? " ui-button5--disabled" : "")}*/}
      {/*        onClick={() => changeSelectedClick(false)}>*/}
      {/*  <span className="ui-button-icon ui-button-icon--grid"/>*/}
      {/*  <FormattedMessage id="wizard.deselectAllButton"/>*/}
      {/*</button>*/}
    </div>
  )
};

const mapStateToProps = (store) => {
  const featuresList = getFilteredFeatures(store);
  const {featuresListReceived, groupName} = store.featuresSetupState;
  const {canEdit, enablePermission} = getFeatureEditPermission(store);

  return {
    featuresList,
    featuresListReceived,
    canAddNewFeatures: canEdit && enablePermission.visible,
    groupName,
  };
};

const mapDispatchToProps = {
  showNewFeatureOverlay
}

export default connect(mapStateToProps, mapDispatchToProps)(FeaturesSetupTopPanelLeft)
